import Image from "next/image";

const Background = ({
  bgImgSrc,
  bgContainerStyles,
  bgImgStyles,
  bgUpSideDown = false,
  bgClassNameContainer = "",
  bgClassNameImg = "",
}) => {
  return (
    <div
      style={bgContainerStyles}
      className={`${bgClassNameContainer} w-screen h-fit pointer-events-none translate-x-4 xs:translate-x-6 lg:translate-x-[88px] xxl:translate-x-[128px] -z-10 overflow-hidden absolute right-0 ${
        bgUpSideDown ? "-top-1 rotate-180" : "bottom-0"
      }`}
    >
      <Image
        style={bgImgStyles}
        className={`${bgClassNameImg} w-full h-full`}
        width={10}
        height={10}
        src={bgImgSrc}
        alt="Background Shape"
      />
    </div>
  );
};

export default Background;
